module.exports = __webpack_public_path__ + "web/img/tpsn_status_20.1e30d8ab.png";